import { RoleAssignmentCreation } from '@/features/role-assignments/components/RoleAssignmentCreation';

const RoleAssignmentCreationPage = () => {
  return <RoleAssignmentCreation />;
};

export default RoleAssignmentCreationPage;
